export default __webpack_public_path__ + "a5a6b8c6f1bab488aa40e9385c9a605b.png";